const ComingSoon: React.FC<any> = ({ component }) => {
  return (
    <div className="w-11/12 flex items-center justify-center mx-auto my-5 p-8 border-2 border-gray-200 rounded text-xl text-gray-500 border-dashed">
      {component} under construction.
    </div>
  );
};

export default ComingSoon;
